import React from 'react';
import './SetHeader.css';
import { Category } from '@mui/icons-material';

const TXT_SET = { fr: 'Panoplie', en: 'Set', de: 'Set', es: 'Set', pt: 'Conjunto' };
const TXT_LVL = { fr: 'niv.', en: 'lvl.', de: 'Stufe', es: 'niv.', pt: 'nív.' };

const SetHeader = ({ set, lang = 'fr' }) => {
    if (!set) return null;

    const setTypeName = TXT_SET[lang] || TXT_SET.en;
    const setItems = set.items || [];
    const maxLevel = setItems.length > 0
        ? Math.max(...setItems.map(item => item.level || 0).filter(level => level > 0))
        : 0;

    return (
        <div className="set-header">
            <div className="set-header-info">
                <Category sx={{ width: 16, height: 16 }} />
                <h6 className="set-header-type">
                    <span>{setTypeName}</span>
                </h6>
                {maxLevel > 0 && (
                    <h6 className="set-header-level">
                        <span className="set-header-level-label">{TXT_LVL[lang] || TXT_LVL.en}</span>
                        <span className="set-header-level-value">{maxLevel}</span>
                    </h6>
                )}
            </div>
        </div>
    );
};

export default SetHeader;
